import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    text: String,
  };

  copy() {
    if (!this.textValue) return;

    const originalHTML = this.element.innerHTML;

    navigator.clipboard
      .writeText(this.textValue)
      .then(() => {
        this.element.innerHTML = '<span class="text-sm text-forest-600">Copied</span>';

        setTimeout(() => {
          this.element.innerHTML = originalHTML;
        }, 2000);
      })
      .catch((error) => {
        console.error("Failed to copy text:", error);
      });
  }
}
